import { useState } from "react";
import { useMutation } from "@apollo/client";

import {
	MARK_BOOST_REPORT_SEEN_MUTATION,
} from "apps/notifications_footer/util/fragments";

function useBoostReport({
	userid,
	activeBoost,
	lastBoost,
	nonBoostActivity,
	isBoostReport,
}) {
	// Toggle Boost report visibility.
	const [isBoostReportExpanded, setIsBoostReportExpanded] = useState(true);
	const toggleBoostReport = () => setIsBoostReportExpanded(!isBoostReportExpanded);

	// When they close out of the Boost report entirely, mark the report as seen.
	// This will refetch our notifications, removing the outdated Boost report ones.
	const [closeBoostReport] = useMutation(MARK_BOOST_REPORT_SEEN_MUTATION, {
		variables: lastBoost ? {
			input: {
				boostId: lastBoost.id,
			},
		} : undefined,
		optimisticResponse: {
			__typename: "Mutation",
			markBoostReportSeen: {
				__typename: "MarkBoostReportSeenPayload",
				user: {
					__typename: "User",
					id: userid,
					activeBoost,
					lastBoost,
					notifications: nonBoostActivity,
				},
			},
		},
	});

	return {
		isBoostReportExpanded: isBoostReport && isBoostReportExpanded,
		toggleBoostReport,
		closeBoostReport,
	};
}

export default useBoostReport;



// WEBPACK FOOTER //
// ./src/apps/notifications_footer/util/useBoostReport.js